import React from 'react';

import cn from 'classnames';

import { BaseFoldableEntity } from './BaseFoldableEntity';
import type { BaseFoldableEntityProps } from './BaseFoldableEntity';
import st from './FoldableEntity.module.sass';
import { buildTestid } from '../../lib/utils';

export type FoldableEntityProps = BaseFoldableEntityProps;

const displayName = 'FoldableEntity';
const testid = buildTestid(displayName);

function FoldableEntity({
  className,
  children = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: FoldableEntityProps): React.JSX.Element {
  return (
    <BaseFoldableEntity
      className={cn(st.FoldableEntity, className)}
      {...testid(dataTestId)}
      {...props}
    >
      {children}
    </BaseFoldableEntity>
  );
}

FoldableEntity.displayName = displayName;

export { FoldableEntity };
